import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { coPath, toWire } from './shared';

/** GET `…/collection-plan`：優先回 APPROVED；無則最新人工草稿／待重新核准版（`crm.customer_order.read`）。 */
export async function fetchCollectionPlan(id) {
  const { data: raw } = await request.get(coPath(id, '/collection-plan'));
  return parseVer4DetailResponse(raw);
}

/** GET `…/collection-plan/versions`：依版本號。 */
export async function fetchCollectionPlanVersions(id) {
  const { data: raw } = await request.get(coPath(id, '/collection-plan/versions'));
  return parseVer4DetailResponse(raw);
}

/** GET `…/collection-plan/{planId}`。 */
export async function fetchCollectionPlanVersion(id, planId) {
  const { data: raw } = await request.get(coPath(id, `/collection-plan/${planId}`));
  return parseVer4DetailResponse(raw);
}

/**
 * PUT `…/collection-plan/manual`：整份人工計畫（客訂 SUBMITTED 後或待改版）。
 * body：`expectedVersionNo`、`expectedCustomerOrderUpdatedAt`、`inputMode`（PERCENTAGE｜AMOUNT）、
 * `phases[]`（`percentage`｜`amount`、`paymentTermId`、`dueDate`、改版承接用 `stablePhaseId`）。
 */
export async function saveManualCollectionPlan(id, payload) {
  const { data: raw } = await request.put(coPath(id, '/collection-plan/manual'), toWire(payload));
  return parseVer4DetailResponse(raw);
}

/** POST `…/collection-plan/{planId}/approve`：`expectedVersionNo`、`expectedCustomerOrderUpdatedAt`。 */
export async function approveCollectionPlan(id, planId, payload) {
  const { data: raw } = await request.post(
    coPath(id, `/collection-plan/${planId}/approve`),
    toWire(payload),
  );
  return parseVer4DetailResponse(raw);
}
